import { DomainRegistry } from "../../../domain";
import {
  IBehaviorDocumentPostPrintingApplicationConfiguration,
  IBehaviorDocumentPostPrintingConfiguration,
} from "../../../domain/configuration";
import { ApplicationLaunchRequest, ApplicationsLaunchRequest } from "../../../domain/localhost/items";
import { User } from "../../../domain/user";

export class PostPrintingApplicationLauncher {
  constructor(private _configuration: IBehaviorDocumentPostPrintingConfiguration) {
  }
  
  private createApplicationLaunchRequest(user: User, patientCode: string, documentId: number, application: IBehaviorDocumentPostPrintingApplicationConfiguration): ApplicationLaunchRequest {
    const request = new ApplicationLaunchRequest();
    request.modulePath = application.modulePath;
    request.argumentsText = this.replaceValues(application.parameter, user, patientCode, documentId);
    return request;
  }

  private replaceValues(parameter: string, user: User, patientCode: string, documentId: number): string {
    if (!parameter) { return parameter; }
    return parameter
      .replace(/%USERCODE%/g, user.id)
      .replace(/%USERID%/g, user.id)
      .replace(/%PATIENTCODE%/g, patientCode)
      .replace(/%PATIENTID%/g, patientCode)
      .replace(/%DOCUMENTID%/g, documentId.toString());
  }

  public async registerApplicationsLaunchRequest(withPrinterSelection: boolean, user: User, patientCode: string, documentId: number): Promise<string> {
    const requests: ApplicationLaunchRequest[] = [];
    for (const application of this._configuration.applications) {
      if (!this.isExecuteTarget(application, withPrinterSelection)) { continue; }
      requests.push(this.createApplicationLaunchRequest(user, patientCode, documentId, application));
    }
    if (requests.length === 0) { return null; }

    const request = new ApplicationsLaunchRequest();
    request.requests = requests;

    const service = DomainRegistry.localhost.getApplicationService();
    return service.registerLaunchRequest(request);
  }

  private isExecuteTarget(application: IBehaviorDocumentPostPrintingApplicationConfiguration, withPrinterSelection: boolean): boolean {
    if (!application.isEnable) { return false; }
    if (application.executeCondition.printerSelection === "any") { return true; }
    return withPrinterSelection
      ? application.executeCondition.printerSelection === "withPrinterSelection"
      : application.executeCondition.printerSelection === "withoutPrinterSelection";
  }
}
